export const OFFLINE_LTS_CALLOUT_TEXT = 'Now check Live Train Status without internet connection on your MMT app!';
export const LIVE_STATUS_API_ENDPOINT = `https://railsinfo-services.makemytrip.com/api/rails/train/livestatus/v2`;
export const SCHEDULED_INTERMEDIATE_API_ENDPOINT = `https://railsinfo-services.makemytrip.com/api/rails/train/scheduleintermediate/v1`;
export const LTS_TRACKING_PARAMS = {
  affiliateCode: 'MMT001',
  channelCode: 'PWA'
};
export const LTS_CUSTOM_HTTP_HEADERS = {
  'Accept-Encoding': 'gzip, deflate, br',
  'Content-Type': 'application/json'
};

export const TRAIN_DETAILS_LTS_TABLE = {
  STATION_NAME: 'Station Name',
  PLATFORM: 'Platform',
  HALT_TIME: 'Halt time',
  SCHEDULED_ARRIVAL: 'Sch. Arrival',
  SCHEDULED_DEPARTURE: 'Sch. Departure',
  ACTUAL_ARRIVAL: 'Act. Arrival',
  ACTUAL_DEPARTURE: 'Act. Departure'
};

export const CHECK_PNR_CARD = {
  TITLE_TEXT: 'Enter the PNR number to check your booking status instantly!',
  DESCRIPTION_TEXT: 'Check Status',
  PNR_PAGE_URL: 'https://www.makemytrip.com/railways/PNR'
};

export const CURRENT_STATION_DETAILS_CARD = {
  ARRIVED_AT_STATION: 'Arrived At Station',
  CROSSED_STATION: 'Crossed Station',
  HALT: '(Halt)',
  NO_HALT: '(No-halt)'
};

export const DAY_NAMES = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export const LTS_CONTENT_VIEW = {
  DISTANCE: 'Distance',
  STATION_NAME: 'Station Name',
  STARTING_POINT: '(Starting point)',
  END_POINT: '(End point)'
};

export const DAY = 'Day';
export const DAYS = 'Days';
export const UPDATED_JUST_NOW = 'Updated just now';
export const LAST_UPDATED = 'Last updated';
